import { useCallback, type Dispatch } from 'react';
import z from 'zod';
import { makeUseAnalytics } from '../hooks/make-use-analytics.ts';
import { createLocalStorageStore } from '../stores/browser-store.ts';
import { useExternalStore } from './use-external-store.ts';

const store = createLocalStorageStore('customer_view_toggled', z.boolean());

const useAnalytics = makeUseAnalytics<{
    customer_view_toggled: {
        enabled: boolean;
    };
}>();

export function useCustomerMode(): [boolean, Dispatch<boolean>] {
    const sendEvent = useAnalytics();
    const [state = false, setState] = useExternalStore(store);

    const setStateWithAnalytics = useCallback(
        (next: boolean) => {
            setState((prev) => {
                if (prev !== next) {
                    sendEvent('customer_view_toggled', { enabled: next });
                }
                return next;
            });
        },
        [setState, sendEvent],
    );
    return [state, setStateWithAnalytics];
}

export function useIsCustomerMode(): boolean {
    const [mode] = useCustomerMode();
    return mode;
}
